import doc                     from 'decorators/doc';
import SupplierPrivateApiModel from '../../abstracts/SupplierPrivateApiModel';

@doc.path('/periods/{?id}/_aggregated_data')
export default class PeriodAggregatedDataModelModel extends SupplierPrivateApiModel {
	@doc.number declare count: number;
	@doc.number declare total: number;
	@doc.number declare totalExclTax: number;
	@doc.number declare totalVat: number;
}